<!-- !! Attention: Student account會共用呢個page，留意返啲permission !! -->
<template>
  <v-container fluid>
    <PageHeaderSlot />

    <Datatable
      :enableSelectAction="canAudit && filter.status === 'pending'"
      :enableSelectToggle="canAudit && filter.status === 'pending'"
      :isLoading="tableLoading"
      :tableData="tableData"
      :tableHeaders="tableHeaders"
      @select-action-changes="handleActionTypeChanged($event)"
      :selectedTableRow.sync="tableSelectedRow"
      @options-update="getRequirements()"
      :page.sync="filter.page"
      :pageLimit.sync="filter.limit"
      :itemTotal="tableItemTotal"
      :selectActionOption="selectActionOptions"
    >
      <template slot="append-toolbar-right">
        <div style="width: 250px;">
          <FormSelect
            :fieldValue.sync="filter.status"
            :options="statusOptions"
            hideDetails
            placeholder="searchStatus"
            class="my-2"
            @changed="searchStatus()"
            :readonly="tableLoading"
            enableClear
          />
        </div>
      </template>
      <template v-slot:[`item.actionStatus`]="{ item }">
        <div class="d-flex" v-if="item.status === 'pending' && canAudit">
          <v-btn
            type="button"
            depressed
            text
            color="success"
            :loading="$store.getters.isLoading"
            @click.prevent="handleStatusActionClick('accepted', item.id)"
          >
            {{ $t('accept') }}
          </v-btn>
          <v-btn
            type="button"
            depressed
            text
            color="red"
            :loading="$store.getters.isLoading"
            @click.prevent="handleStatusActionClick('rejected', item.id)"
          >
            {{ $t('reject') }}
          </v-btn>
        </div>
        <v-chip
          v-else
          :class="{
            'chip-success': item.status === 'accepted',
            'chip-error': item.status === 'rejected',
            'chip-inactive': item.status === 'pending',
          }"
        >
          {{ $t(`requirementStatus.${item.status}`) }}
        </v-chip>
      </template>
    </Datatable>
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'
import FormSelect from '@/components/formField/FormSelect.vue'
export default {
  name: 'SwitchRequirement',
  inject: ['getConfirmDialogRef'],
  components: {
    Datatable,
    FormSelect,
  },
  computed: {
    confirmRef() {
      return this.getConfirmDialogRef()
    },
    tableHeaders() {
      const vm = this
      return [
        { value: 'create_date', text: vm.$t('createdDate'), width: 130 },
        { value: 'student_name', text: vm.$t('name') },
        { value: 'requirement', text: vm.$t('requirement') },
        {
          value: 'actionStatus',
          text: !vm.canAudit || vm.filter.status !== 'pending' ? vm.$t('status') : '',
          align: 'center',
          width: !vm.canAudit || vm.filter.status !== 'pending' ? 150 : 250,
        },
      ]
    },
    // permission & setting
    canAudit() {
      return this.$validate.allowAction('canAuditReq', this.userType)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    tableLoading: false,
    tableData: [],
    tableItemTotal: 0,
    tableSelectedRow: [],
    filter: {
      status: 'pending',
      user_id: null,
      page: 1,
      limit: 10,
    },

    // - static
    selectActionOptions: [
      { text: vm.$t('accept'), value: 'accepted' },
      { text: vm.$t('reject'), value: 'rejected' },
    ],
    statusOptions: [
      { text: vm.$t('requirementStatus.pending'), value: 'pending' },
      { text: vm.$t('requirementStatus.accepted'), value: 'accepted' },
      { text: vm.$t('requirementStatus.rejected'), value: 'rejected' },
    ],
  }),
  methods: {
    async getRequirements(regenUrl = true) {
      if (regenUrl) this._regenerateURL()

      this.tableLoading = true
      try {
        // ---------------- payload ----------------
        let payload = {
          filter_limit: this.filter.limit,
          filter_page: this.filter.page - 1,
          join_student_data: true,
          join_lesson_data: true,
          filter_item: [{ key: 'approve_status', value: this.filter.status }],
        }

        if (this.$validate.DataValid(this.filter.user_id) && this.filter.user_id > -1) {
          payload['filter_item'].push({ key: 'student_id', value: this.filter.user_id })
        }
        // -------------- End of payload -------------

        const { data, total } = await this.$Fetcher.GetRequirements(payload)
        this.tableData = data.map(item => {
          let requirement = ''
          if (item.to_lesson_data && item.from_lesson_data) {
            requirement = this.$t('switchDes', {
              from_name: item.from_lesson_data.course_name,
              from_date: `${item.from_lesson_data.date} (${this.$d(
                this.$formatter.convertDate(item.from_lesson_data.date),
                'weekdayShort',
              )})`,
              from_start_time: item.from_lesson_data.start_time,
              from_end_time: item.from_lesson_data.end_time,
              to_name: item.to_lesson_data.course_name,
              to_date: `${item.to_lesson_data.date} (${this.$d(
                this.$formatter.convertDate(item.to_lesson_data.date),
                'weekdayShort',
              )})`,
              to_start_time: item.to_lesson_data.start_time,
              to_end_time: item.to_lesson_data.end_time,
            })
          }
          return {
            ...item,
            requirement: requirement,
            disabled: item.status !== 'pending',
          }
        })

        this.tableItemTotal = total
      } catch (err) {
        this.$common.error(err)
        this.tableData = []
        if (this.filter.page === 1) {
          this.tableItemTotal = 0
        }
      } finally {
        this.tableLoading = false
      }
    },
    searchStatus() {
      this.filter.page = 1
      this.tableSelectedRow = []
      this.getRequirements()
    },

    _getQuery() {
      this.filter.page = 1
      this.filter.limit = 10
      this.filter.status = 'pending'
      const query = this.gfGetTableQuery({
        page: 'int',
        limit: 'int',
        status: ['pending', 'accepted', 'rejected'],
      })
      for (const key in this.filter) {
        if (this.$validate.DataValid(query[key])) {
          this.$set(this.filter, key, query[key])
        }
      }
    },
    _regenerateURL() {
      let q = {
        page: this.filter.limit !== 10 || this.filter.page !== 1 ? this.filter.page : null,
        limit: this.filter.limit !== 10 || this.filter.page !== 1 ? this.filter.limit : null,
        status: this.filter.status === 'pending' ? undefined : this.filter.status,
      }
      const newQuery = this.$common.diffQuery(q, this.$route.query)
      if (newQuery) {
        this.$router.replace({ query: newQuery })
      }
    },

    // -- (接受/拒絕)
    async handleStatusActionClick(status, id) {
      if (!this.canAudit) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const found = this.tableData.find(el => el.id === id)
      if (found.status !== 'pending') {
        this.showAlert({
          title: 'message.updateFail',
          message: 'message.notPendingRequestExist',
          isError: true,
        })
        return
      }

      const confirm = await this.confirmRef.show({
        title: 'message.confirmUpdateStatus',
        message: 'message.confirmUpdateStatusMsg',
      })
      if (confirm) {
        this._updateStatus(status, [id])
      }
    },
    // -- (Multiple 接受/拒絕)
    async handleActionTypeChanged(status) {
      if (!this.canAudit) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      if (this.tableData.length < 1 || this.tableSelectedRow.length < 1) {
        this.$store.dispatch('toggleSnack', {
          message: 'message.atLeastOneRequirement',
          type: 'error',
        })
        return
      }

      let valid = true
      for (let i = 0; i < this.tableSelectedRow.length; i++) {
        const found = this.tableData.find(el => el.id === this.tableSelectedRow[i].id)
        if (found && found.status !== 'pending') {
          this.showAlert({
            title: 'message.updateFail',
            message: 'message.notPendingRequestExist',
            isError: true,
          })
          valid = false
          break
        }
      }
      if (!valid) return

      const confirm = await this.confirmRef.show({
        title: 'message.confirmUpdateStatus',
        message: 'message.confirmUpdateStatusMsg',
      })
      if (confirm) {
        this._updateStatus(
          status,
          this.tableSelectedRow.map(el => el.id),
        )
      }
    },
    async _updateStatus(status, idList) {
      this.$store.dispatch('setLoading', true)

      try {
        let data = null
        if (status === 'accepted') {
          data = await this.$Fetcher.ApproveRequirements(idList)
        } else if (status === 'rejected') {
          data = await this.$Fetcher.RejectRequirements(idList)
        }

        if (data !== true) {
          const list = data.map(el => {
            const found = this.tableData.find(elm => elm.id === el.id)
            if (found) return found.requirement
            return ''
          })
          this.showAlert({
            title: '',
            message: this.$t('message.switchRequestError', { list: list.join('\n') }),
            isError: true,
          })
        } else {
          this.$store.dispatch('toggleSnack', {
            message: 'message.updateSuccess',
            type: 'success',
          })
        }

        this.$store.dispatch('setLoading', false)
        this.filter.page = 1
        this.getRequirements()
      } catch (err) {
        this.$store.dispatch('setLoading', false)
        this.showAlert({
          title: 'message.updateFail',
          message: err,
          isError: true,
        })
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: SwitchRequirement')
      this.userType = this.gfGetUserType()
      if (this.userType === 'student') {
        const userData = this.gfGetCurrentUserData()
        this.filter.user_id = userData.id
      }
      this._getQuery()
      this.$store.dispatch('toggleLoadingPage', false)

      this.getRequirements(false)
    },
  },
  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.tableLoading = true
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else {
      this.$XHR.abort()
      next()
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .custom-table-toolbar .toolbar-right-items {
  justify-content: flex-end !important;
}
@media screen and (max-width: 970px) {
  ::v-deep .custom-table.show-select {
    .custom-table-toolbar {
      & .v-toolbar__content {
        padding-top: 50px !important;
      }
    }
  }
}
</style>
